import { AbstractRectangleItem } from "./AbstractRectangleItem";
import { IItem } from "./IItem";
import { ISourceEditable } from "./ISourceEditable";

export abstract class AbstractSourceEditableItem extends AbstractRectangleItem implements ISourceEditable {
  constructor(typeKey: string) {
    super(typeKey);
  }

  public source: IItem;

  protected applyMembers(clone: AbstractSourceEditableItem): void {
    super.applyMembers(clone);
    // sourceが更新されてない時は更新かかってほしくないのでsourceはcloneしない.(更新時にclone.)
    clone.source = this.source;
  }
}
